/*
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Tracking Number Update Component. User can update tracking numbers for picking orders.
 * 
 * App Name: SDI-Walmart
 * Author: Deepthi N H
 * Created Date: 01/11/2023
 */
import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import swal from 'sweetalert';
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next'
import * as MenuAction from '../actions/MenuAction';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import * as TrackingNoUpdateAction from '../actions/TrackingNoUpdateAction';
import TrackingNoUpdateStore from '../stores/TrackingNoUpdateStore';
let currentPagePath;
let updateEditedIndex;
let globalTrackingArray = [];
class TrackingNoUpdateComponent extends Component {
    constructor(props) {
        super(props);
        this.SortClick = this.SortClick.bind(this);
        this.state = {
            pageLoadGridArray: [],
            isFavorited: false,
            RecCount: 10,
            totalCount: 0,
            pageCount: 0,
            PageNo: 1,
            CribId: "",
            orderNumber: "",
            editedIndex: "",
        }
    };
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " ") {
            //let CribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        TrackingNoUpdateAction.getCurrentFavPage(getFavPageBO);
        this.PageLoad();
        TrackingNoUpdateStore.on('TrackinNoPageLoad', this.PageLoadResponse.bind(this));
        TrackingNoUpdateStore.on('OrderSearchData', this.GoClickResponse.bind(this));
        TrackingNoUpdateStore.on('UpdateResponses', this.TrackingNoUpdateRespose.bind(this));
        TrackingNoUpdateStore.on('favpage', this.loadFavPageResponse.bind(this));
        TrackingNoUpdateStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
    }
    componentWillUnmount() {
        TrackingNoUpdateStore.removeListener('TrackinNoPageLoad', this.PageLoadResponse);
        TrackingNoUpdateStore.removeListener('OrderSearchData', this.GoClickResponse);
        TrackingNoUpdateStore.removeListener('UpdateResponses', this.TrackingNoUpdateRespose);
        TrackingNoUpdateStore.removeListener('favpage', this.loadFavPageResponse);
        TrackingNoUpdateStore.removeListener('updateFavPage', this.updateFavPageResponse);
    }
    PageLoad = () => {
        let TrackingNoPageLoadBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        TrackingNoUpdateAction.PageLoadData(TrackingNoPageLoadBO);
    }
    PageLoadResponse = () => {

        let pageLoadResponse = JSON.parse(TrackingNoUpdateStore.TrackinNoPageLoad);
        let cribData = pageLoadResponse.CribTable;
        let pageLoadData = pageLoadResponse.PageLoadTable;
        if (cribData[0].ExceptionError != undefined) {
            if (cribData[0].ExceptionError != "") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Oops, Something went wrong"
                });
                return;
            }
        }
        else {
            let cribID = cribData[0].CribID;
            if (pageLoadData != undefined) {
                if (pageLoadData.length > 0) {
                    pageLoadData.forEach((value, index) => {
                        value.EditedTrackingNo = value.TRACKING_NUMBER.trim();
                        if (value.TRACKING_NUMBER != null && value.TRACKING_NUMBER.trim() != "") {
                            value.IsEditClicked = false;
                        }
                        else {
                            value.IsEditClicked = true;
                        }
                    });
                }
            }
            let orderCount = pageLoadData.length;
            let totalCount = orderCount > 0 ? orderCount : 0;
            let pg = Math.ceil((orderCount > 0 ? orderCount : 0) / this.state.RecCount);
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            this.setState({ totalCount: totalCount, pageCount: pg, pageLoadGridArray: pageLoadData, CribId: cribID, orderNumber: "", PageNo: 1 });
        }
    }
    OrderNoOnChange = (e) => {
        let regex = SDIConstants.alphanumericRegex
        const value = e.target.value;
        if (regex.test(value) || value === "") {
            this.setState({ orderNumber: e.target.value });
        }
    }
    ClearSearch = () => {
        this.setState({ orderNumber: "" })
    }
    ClearSearch = () => {
        this.setState({ orderNumber: "" })
    }
    GetCribData = (e) => {
        this.PageLoad();
    }
    keyPress = (e) => {
        if (e.keyCode == 13) {
            { this.GoClick(e) };
        }
    }
    GoClick = (e) => {
        if (this.state.orderNumber.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter order number"
            });
            return;
        }
        else {
            let SearchPickingOrderBO = {
                OrderNumber: this.state.orderNumber.trim(),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                CribID: this.state.CribId
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            TrackingNoUpdateAction.SearchPickingOrder(SearchPickingOrderBO);
        }
    }
    GoClickResponse = () => {
        let searchOrderData = JSON.parse(TrackingNoUpdateStore.OrderSearchData);
        if (searchOrderData != undefined) {
            if (searchOrderData.length > 0) {
                if (searchOrderData[0].ExceptionError != undefined) {
                    if (searchOrderData[0].ExceptionError != "") {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Oops, Something went wrong"
                        });
                        return;
                    }
                }
                else {
                    if (searchOrderData != undefined) {
                        if (searchOrderData.length > 0) {
                            searchOrderData.forEach((value, index) => {
                                value.EditedTrackingNo = value.TRACKING_NUMBER.trim();
                                if (value.TRACKING_NUMBER != null && value.TRACKING_NUMBER.trim() != "") {
                                    value.IsEditClicked = false;
                                }
                                else {
                                    value.IsEditClicked = true;
                                }
                            });
                        }
                    }
                    let orderCount = searchOrderData.length;
                    let totalCount = orderCount > 0 ? orderCount : 0;
                    let pg = Math.ceil((orderCount > 0 ? orderCount : 0) / this.state.RecCount);
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    this.setState({ totalCount: totalCount, pageCount: pg, pageLoadGridArray: searchOrderData, PageNo: 1 });
                }
            }
            else {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ totalCount: 0, pageCount: 0, pageLoadGridArray: [] });
            }

        }

    }
    updateFavPageResponse = () => {
        if (TrackingNoUpdateStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(TrackingNoUpdateStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(TrackingNoUpdateStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };
    /**
    * Handle change method for favorite page checkbox
    * @param event
    */
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Tracking Number Update",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            TrackingNoUpdateAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            TrackingNoUpdateAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /**
    * Listener method for loading favorite page icon
    */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(TrackingNoUpdateStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    TrackingNoOnChange = (e, index) => {
        let { pageLoadGridArray } = this.state;
        const re = SDIConstants.alphanumericRegex;
        if (re.test(e.target.value) || e.target.value == "") {
            pageLoadGridArray[index].EditedTrackingNo = e.target.value;
            this.setState({ pageLoadGridArray });
        }
    }

    OnUpdateClick = (e, index) => {
        let { pageLoadGridArray } = this.state;
        globalTrackingArray = pageLoadGridArray;

        updateEditedIndex = index;
        console.log("deepthieditindex", updateEditedIndex);
        console.log("this.state.pageLoadGridArray[index]", pageLoadGridArray[index]);
        if (pageLoadGridArray[index].EditedTrackingNo.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter tracking number"
            });
            return;
        }
        else {
            let UpdateTrackingNoBO = {
                OrderNumber: pageLoadGridArray[index].ORDER_NUMBER,
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                CribID: this.state.CribId,
                LineNo: pageLoadGridArray[index].ORDER_LINE,
                Tracking_No: pageLoadGridArray[index].EditedTrackingNo.trim()
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            TrackingNoUpdateAction.UpdateTrackingNo(UpdateTrackingNoBO);
        }

    }
    onEditClick = (e, index) => {
        let { pageLoadGridArray } = this.state;
        pageLoadGridArray[index].IsEditClicked = true;
        this.setState({ pageLoadGridArray });
    };
    onCancelClick = (e, index) => {

        let { pageLoadGridArray } = this.state;
        pageLoadGridArray[index].EditedTrackingNo = pageLoadGridArray[index].TRACKING_NUMBER.trim();
        if (pageLoadGridArray[index].TRACKING_NUMBER.trim() == "" || pageLoadGridArray[index].TRACKING_NUMBER.trim() == null) {
            pageLoadGridArray[index].IsEditClicked = true;
        }
        else {
            pageLoadGridArray[index].IsEditClicked = false;
        }
        this.setState({ pageLoadGridArray })
    };
    TrackingNoUpdateRespose = () => {

        let UpdateResponse = JSON.parse(TrackingNoUpdateStore.UpdateResponse);
        if (UpdateResponse != undefined) {
            if (UpdateResponse.length > 0) {
                if (UpdateResponse[0].ExceptionError != undefined) {
                    if (UpdateResponse[0].ExceptionError != "") {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Oops, Something went wrong"
                        });
                        return;
                    }
                }
                else {
                    let index = updateEditedIndex;
                    let { pageLoadGridArray } = this.state;
                    let loctrackingArray = globalTrackingArray;
                    if (UpdateResponse[0].UpdateMessage == "Successfully Updated") {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        loctrackingArray[index].IsEditClicked = false;
                        loctrackingArray[index].TRACKING_NUMBER = loctrackingArray[index].EditedTrackingNo;
                        this.setState({ pageLoadGridArray: loctrackingArray });
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Successfully updated tracking number"
                        });
                        return;
                    }
                    else {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Tracking number update failed"
                        });
                        return;
                    }
                }
            }
        }
    }
    ManualSort = (a, b, OrdOrItem, Type) => {
        ;
        let first;
        let sec;
        if (OrdOrItem == "Ord") {
            first = parseInt(a.toUpperCase().replace('WM', ''));
            sec = parseInt(b.toUpperCase().replace('WM', ''));
        }
        else {
            first = parseInt(a.toUpperCase().replace('W', ''));
            sec = parseInt(b.toUpperCase().replace('W', ''));

        }
        if (Type == "ASC") {
            return first === sec ? 0 : first > sec ? 1 : -1;
        }
        else {
            return first === sec ? 0 : first > sec ? -1 : 1;
        }
    }
    SortClick = (Type, ColumnName) => {

        let { pageLoadGridArray } = this.state;
        if (Type == "ASC") {
            if (ColumnName == "OrderNo") {
                //pageLoadGridArray.sort((a, b) => a.ORDER_NUMBER.toUpperCase() - b.ORDER_NUMBER.toUpperCase());
                pageLoadGridArray.sort((a, b) => this.ManualSort(a.ORDER_NUMBER, b.ORDER_NUMBER, "Ord", "ASC"));
                //pageLoadGridArray.sort(function (a, b) {
                //    let textA = parseInt(a.ORDER_NUMBER.toUpperCase());
                //    let textB = parseInt(b.ORDER_NUMBER.toUpperCase());
                //    return (textA > textB) ? 1 : -1;
                //});
            }
            else if (ColumnName == "ItemID") {
                //pageLoadGridArray.sort((a, b) => a.ITEM_ID.toUpperCase() - b.ITEM_ID.toUpperCase());
                pageLoadGridArray.sort((a, b) => this.ManualSort(a.ITEM_ID, b.ITEM_ID, "Item", "ASC"));
                //pageLoadGridArray.sort((a, b) => (a.ITEM_ID > b.ITEM_ID) ? 1 : -1);
                //pageLoadGridArray.sort(function (a, b) {
                //    let textA = parseInt(a.ITEM_ID.toUpperCase());
                //    let textB = parseInt(b.ITEM_ID.toUpperCase());
                //    return (textA > textB) ? 1 : -1;
                //});
            }
        }
        else {
            if (ColumnName == "OrderNo") {
                //pageLoadGridArray.sort((a, b) => b.ORDER_NUMBER.toUpperCase() - a.ORDER_NUMBER.toUpperCase());
                //pageLoadGridArray.sort((a, b) => (a.ORDER_NUMBER > b.ORDER_NUMBER) ? -1 : 1);
                pageLoadGridArray.sort((a, b) => this.ManualSort(a.ORDER_NUMBER, b.ORDER_NUMBER, "Ord", "DESC"));
                //pageLoadGridArray.sort(function (a, b) {
                //    let textA = parseInt(a.ORDER_NUMBER.toUpperCase());
                //    let textB = parseInt(b.ORDER_NUMBER.toUpperCase());
                //    return (textA > textB) ? -1 : 1;
                //});
            }
            else if (ColumnName == "ItemID") {
                //pageLoadGridArray.sort((a, b) => b.ITEM_ID.toUpperCase() - a.ITEM_ID.toUpperCase());
                //pageLoadGridArray.sort((a, b) => (a.ITEM_ID > b.ITEM_ID) ? -1 : 1);
                pageLoadGridArray.sort((a, b) => this.ManualSort(a.ITEM_ID, b.ITEM_ID, "Item", "DESC"));
                //pageLoadGridArray.sort(function (a, b) {
                //    let textA = a.ITEM_ID.toUpperCase();
                //    let textB = b.ITEM_ID.toUpperCase();
                //    return (textA > textB) ? -1 : 1;
                //});
            }
        }
        this.setState({ pageLoadGridArray })
    }
    HandlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ PageNo: pageNo });
    }
    BindPickingOrders = () => {

        if (this.state.pageLoadGridArray.length > 0) {
            return this.state.pageLoadGridArray.map((value, index) => {
                if (index < parseInt(this.state.PageNo) * 10 && index >= parseInt(this.state.PageNo - 1) * 10) {
                    return (<React.Fragment key={index}>
                        <tr>

                            <td>{value.WAREHOUSE}</td>
                            <td>{value.ORDER_NUMBER}</td>
                            <td>{value.ORDER_LINE}</td>
                            <td>{value.ITEM_ID}</td>
                            <td>{value.CONTAINER_TYPE}</td>
                            <td>{value.CONTAINER_ID}</td>
                            <td>{value.STORAGE_AREA}</td>
                            <td>{value.STOR_LEVEL_1}</td>
                            <td>{value.STOR_LEVEL_2}</td>
                            <td>{value.STOR_LEVEL_3}</td>
                            <td>{value.STOR_LEVEL_4}</td>
                            {value.IsEditClicked == false ? <td>
                                {value.TRACKING_NUMBER}
                            </td> :
                                <td >
                                    <input type="text" className="form-control" placeholder="Enter Value" maxLength="20" name="EditExisAis" value={value.EditedTrackingNo} onChange={e => this.TrackingNoOnChange(e, index)} />
                                </td>}
                            {value.IsEditClicked == false ?
                                < td >
                                    <td className="text-center px-0" style={{ "borderBottom": "0px solid" }}><span onClick={(e) => this.onEditClick(e, index)}><img className="px-1" src="Images/edit-icon.png" alt="Edit" title="Edit" style={{ height: '17px' }} /></span></td>
                                </td> :
                                <td>
                                    <td className="text-center px-0" style={{ "borderBottom": "0px solid" }}><span onClick={(e) => this.OnUpdateClick(e, index)}><img className="px-1" src="Images/tick.png" alt="Save" title="Save" style={{ "height": '17px', "borderBottom": "0px solid" }} /></span>{value.TRACKING_NUMBER.trim() != "" ? <span onClick={(e) => this.onCancelClick(e, index)}><img src="Images/cancel-icon.svg" alt="Cancel" title="Cancel" style={{ "height": '17px', "borderBottom": "0px solid" }} /></span> : null}</td>
                                </td>}
                        </tr>
                    </React.Fragment>

                    );
                }

            })

        }
    }
    render() {
        return (
            <>
                <div className="container-fluid content-section custom-mb">
                    <div className="row">
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title"><Trans>Tracking Number Update</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-Fav" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-Fav">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-12 my-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-4" style={{ "maxWidth":"24%"}}>
                                        <div className="row">
                                            <label className="catalog-label mt-2 ml-2"><Trans>Order Number</Trans></label>
                                            <div className="col-sm-12 col-lg-7 px-2 ml-4">
                                                    <input type="text" className="form-control" id="OrderNumber" placeholder="Order #" maxLength="10" value={this.state.orderNumber} onChange={e => this.OrderNoOnChange(e)} />
                                                    {this.state.orderNumber ? <span className="search-cancel-header cursor-pointer" style={{ "right": "20px" }} onClick={() => this.ClearSearch()}></span> : null}
                                            </div>
                                        </div>
                                        </div>
                                        <div className="ml-1">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={e => this.GoClick(e)} ><Trans>GO</Trans></button>
                                        </div>
                                        <div className="ml-1">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={e => this.GetCribData(e)} ><Trans>Get Crib Data</Trans></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                {this.state.pageLoadGridArray.length > 0 ? <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                    <thead>
                                        <tr>

                                            <th className="position-sort-icon" style={{ "width": "20px" }}><Trans>Crib</Trans></th>
                                            <th className="d-sm-none d-md-table-cell" style={{ "width": "15px" }}><Trans>Order Number</Trans><span className="sort-up1 ml-1 mb-1" ><img src="Images/sort2.svg" onClick={(e) => this.SortClick("ASC", "OrderNo")} /></span><span className="sort-downt ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick("DESC", "OrderNo")} /></span></th>
                                            <th className="d-md-table-cell" style={{ "width": "40px" }}><Trans>Order Line No</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "5px" }}><Trans>Item ID</Trans><span className="sort-up1 ml-1 mb-1"  ><img src="Images/sort2.svg" onClick={(e) => this.SortClick("ASC", "ItemID")} /></span><span className="sort-down ml-1" ><img src="Images/sort1.svg" onClick={(e) => this.SortClick("DESC", "ItemID")} /></span></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Container Type</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Container ID</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Area</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Aisle</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Row</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Shelf</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Bin</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "5px" }}><Trans>Tracking Number</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "5px" }}><Trans>Action</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.pageLoadGridArray.length > 0 ? this.BindPickingOrders() :
                                            (
                                                <tr>
                                                    <td colSpan={11}>
                                                        <section className="site-undercontruction container text-center center-panel pt-4">
                                                            <div className="img-section">
                                                                <img src="images/nosearch.jpg" alt="imagefile" />
                                                            </div>
                                                            <p className="search-result-content pt-4"><Trans>Sorry, we couldn’t find any search result</Trans>
                                                            </p>
                                                        </section>
                                                    </td>
                                                </tr>)}
                                        </tbody>
                                    </table>:null}
                                {this.state.pageLoadGridArray.length > 0 ?
                                    <div className="col-md-12 ">
                                        <span className="total-records mt-2 d-inline-block">
                                            <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                        </span>
                                        {this.state.totalCount > 10 ? <ReactPaginate
                                            previousLabel={<span className="right-pagination-arrow" />}
                                            nextLabel={<span className="left-pagination-arrow" />}
                                            previousClassName={'page-item'}
                                            nextClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextLinkClassName={'page-link'}
                                            disabledClassName={'disabled'}
                                            breakLabel={'...'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={this.HandlePageClick}
                                            containerClassName={'custom-pagination pagination float-right'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                            hrefBuilder={() => '#'}
                                            forcePage={this.state.PageNo - 1}
                                        /> : null}

                                    </div> : <section className="site-undercontruction container text-center center-panel pt-4">
                                        <div className="img-section">
                                            <img src="images/nosearch.jpg" alt="imagefile" />
                                        </div>
                                        <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                        </p>
                                    </section>}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default withTranslation()(TrackingNoUpdateComponent);